import React from 'react';
import './Assets/stylesheets/common.scss';
import { ToastContainer } from 'react-toastify';
import AppRouter from './AppRouter';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  console.log(process.env.REACT_APP_ENVIROMENT);

  return (
    <div className="App">
      <AppRouter />
      <ToastContainer />
    </div>
  );
}
export default App;
